import { BuildingShop24Filled, BuildingShop24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const CustomerHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "CustomerHubApp" */ "./CustomerHubApp");
    return { default: namedExport.CustomerHubApp };
});

export const CustomerHub: TeamAppConfig = {
    title: "Customer Hub",
    regularIcon: BuildingShop24Regular,
    filledIcon: BuildingShop24Filled,
    path: "/customerhub",
    description: "Customer Hub focuses on monitoring each Tenant and priority account experience for M365 services to assert service health.",
    team: "EndUserMonitoring",
    publicId: "Exchange\\EndUserMonitoring",
    owner: "eum_scp@microsoft.com",
    role: "*",
    tags: [],
    app: CustomerHubApp
};
